let obj = {};
// 保险期限
obj.guarantPre = [
  {
    key: 'MONTH_1',
    value: '1个月'
  },
  {
    key: 'MONTH_3',
    value: '3个月'
  },
  {
    key: 'MONTH_6',
    value: '6个月'
  },
  {
    key: 'YEAR_12',
    value: '1年'
  }
];
// 企业证件类型
obj.companyIdTypeOptions = [
  {
    value: '01',
    name: '组织机构代码证'
  },
  {
    value: '03',
    name: '统一社会信用代码'
  }
];
// 企业类别
obj.companyPropertyList = [
  {
    value: '1',
    text: '全民所有制企业'
  },
  {
    value: '2',
    text: '集体所有制企业'
  },
  {
    value: '3',
    text: '联营企业'
  },
  {
    value: '4',
    text: '在中华人民共和国境内设立的中外合资经营企业、中外合作经营企业和外资企业'
  },
  {
    value: '5',
    text: '私营企业'
  },
  {
    value: '6',
    text: '依法需要办理企业法人登记的其他企业'
  }
];
// 注册资本币种
obj.vehicleOptions = [
  {
    value: 'CNY',
    text: '人民币元'
  },
  {
    value: 'USD',
    text: '美元'
  },
  {
    value: 'EUR',
    text: '欧元'
  },
  {
    value: 'JPY',
    text: '日元'
  },
  {
    value: 'GBP',
    text: '英镑'
  },
  {
    value: 'AUD',
    text: '澳大利亚元'
  },
  {
    value: 'CHF',
    text: '瑞士法郎'
  },
  {
    value: 'CAD',
    text: '加元'
  },
  {
    value: 'KRW',
    text: '韩元'
  }
];

obj.KZSCOptions = [
  {
    value: -1,
    name: '不附加'
  },
  {
    value: 1,
    name: '附加'
  }
];
obj.attendOptions = [
  {
    value: 'N',
    name: '不附加'
  },
  {
    value: 'Y',
    name: '附加'
  }
];
obj.extendOptions = [
  {
    value: 'N',
    name: '不拓展'
  },
  {
    value: 'Y',
    name: '拓展'
  }
];
obj.occupationOptionsLevel = [
  {
    value: '1',
    name: '1类'
  },
  {
    value: '2',
    name: '2类'
  },
  {
    value: '3',
    name: '3类'
  },
  {
    value: '4',
    name: '4类'
  },
  {
    value: '5',
    name: '5类'
  },
  {
    value: '6',
    name: '6类'
  }
];
obj.IdTypeOptions = [
  {
    value: '1',
    name: '身份证'
  }
];
obj.sexOptions = [
  {
    value: 'M',
    name: '男'
  },
  {
    value: 'F',
    name: '女'
  }
];
obj.plansValues = [
  {
    value: '1',
    name: '计划一',
    money: '10万',
    money1: '1万',
    money2: '100元/天'
  },
  {
    value: '2',
    name: '计划二',
    money: '20万',
    money1: '2万',
    money2: '100元/天'
  },
  {
    value: '3',
    name: '计划三',
    money: '30万',
    money1: '3万',
    money2: '100元/天'
  },
  {
    value: '4',
    name: '计划四',
    money: '40万',
    money1: '4万',
    money2: '100元/天'
  },
  {
    value: '5',
    name: '计划五',
    money: '50万',
    money1: '5万',
    money2: '100元/天'
  },
  {
    value: '6',
    name: '计划六',
    money: '60万',
    money1: '6万',
    money2: '100元/天'
  },
  {
    value: '7',
    name: '计划七',
    money: '70万',
    money1: '7万',
    money2: '100元/天'
  },
  {
    value: '8',
    name: '计划八',
    money: '80万',
    money1: '8万',
    money2: '100元/天'
  },
  {
    value: '9',
    name: '计划九',
    money: '90万',
    money1: '9万',
    money2: '100元/天'
  },
  {
    value: '10',
    name: '计划十',
    money: '100万',
    money1: '10万',
    money2: '100元/天'
  }
];
obj.columns = [
  {
    title: '序号',
    scopedSlots: { customRender: 'num' }
  },
  {
    title: '姓名',
    dataIndex: 'name'
  },
  {
    title: '证件类型',
    dataIndex: 'idType',
    key: 'idType',
    scopedSlots: { customRender: 'idType' }
  },
  {
    title: '证件号码',
    dataIndex: 'idNumber'
  },
  {
    title: '出生日期',
    dataIndex: 'birthDate'
  },
  {
    title: '性别',
    dataIndex: 'gender',
    key: 'gender',
    scopedSlots: { customRender: 'gender' }
  },
  {
    title: '职业代码',
    dataIndex: 'occupationCode'
  },
  {
    title: '职业名称',
    dataIndex: 'occupationName'
  },
  {
    title: '职业类别',
    dataIndex: 'occulevel',
    scopedSlots: { customRender: 'occulevel' }
  }
];
export default { ...obj };
